import { fmtDateShort } from '../../shared/format';

function toDate(input) {
  return input instanceof Date ? input : new Date(input);
}

export function buildTransactionPayload(source, overrides = {}) {
  const base = {
    date:
      source.date instanceof Date
        ? source.date.toISOString()
        : new Date(source.date).toISOString(),
    description: source.description,
    amount: Number(source.amount),
    type: source.type,
    withdrawnFromPersonal: Boolean(source.withdrawnFromPersonal),
    withdrawnFromBank: Boolean(source.withdrawnFromBank),
    category: source.category || 'uncategorized',
  };
  return { ...base, ...overrides };
}

export function computeStatsMeta(transactions = []) {
  const credits = transactions.filter((t) => t.type === 'credit');
  const debits = transactions.filter((t) => t.type === 'debit');

  const creditMax = credits.reduce(
    (acc, t) => {
      const d = toDate(t.date);
      return !acc || d > acc ? d : acc;
    },
    null
  );

  const debitMax = debits.reduce((acc, t) => (t.amount > acc ? t.amount : acc), 0);

  return {
    credit: {
      count: credits.length,
      lastDate: creditMax ? fmtDateShort(creditMax) : null,
    },
    debit: {
      count: debits.length,
      maxAmount: debitMax,
    },
  };
}
